












































































import {
  Vue, Component, Prop, PropSync, Watch,
} from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import { User, UserApi, PartnersApi } from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import Textfield from '@/components/Form/Textfield/index.vue';
import ContactInformation from '@/components/Form/Partner/ContactInformation/index.vue';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import Format from '@/util/Format';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import PermissionMixin from '../../../../mixins/PermissionMixin';

@Component({
  components: {
    Textfield,
    ContactInformation,
    EditConfirmation,
  },
})
export default class ContactInfomationEdit extends mixins(PermissionMixin) {
  @PropSync('contactInfo', { default: null }) contactInfoSync!: User | null;

  @Prop({}) readonly partnerID!: string;

  @PropSync('partnerOwnerName', { default: '' }) partnerOwnerNameSync!: string;

  public saving: boolean = false;

  public contactInfoLocal: any = {};

  public edit: boolean = false;

  @Watch('contactInfoSync', { immediate: true, deep: true })
  onContactInfoChanged(val: User | null) {
    if (!val) return;
    this.contactInfoLocal = cloneDeep(val);
  }

  get contactDisplayName() {
    if (this.partnerOwnerNameSync) {
      return this.partnerOwnerNameSync;
    }
    return Format.getFormattedName(this.contactInfoLocal);
  }

  get contactNumber() {
    const phone = this.contactInfoLocal?.phone?.phone;
    if (phone === undefined || phone === null || phone === '') {
      return '';
    }
    return Format.maskPhoneNumber(phone) || String(phone);
  }

  public async onEdit() {
    if (this.contactInfoSync) {
      this.contactInfoLocal = cloneDeep(this.contactInfoSync);
    }
    this.edit = false;
  }

  get onBoardingPartner() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return UserModule.currentPartner.id;
    }
    return null;
  }

  public async onSave() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    this.saving = true;
    try {
      if (this.onBoardingPartner) {
        await this.saveContactUser();
      } else {
        await this.savePartnerOwner();
      }
      this.edit = false;
    } catch (err) {
      console.log(err);
    }
    this.saving = false;
  }

  private async saveContactUser() {
    const contactInfo = cloneDeep(this.contactInfoLocal);
    const rawPhone = contactInfo?.phone?.phone;
    const contactPhone: any = {
      phone: rawPhone ? Format.CheckMaskNumber(rawPhone) : '',
    };

    const userData: User = {
      id: contactInfo.id,
      email: contactInfo.email,
      name: contactInfo.name,
      phone: contactPhone,
      title: contactInfo.title,
    };

    const api = new UserApi(AppModule.apiConfig);
    await api.patchUser(contactInfo.id, userData);
    const userUpdateData = await api.getUser(contactInfo.id);
    await this.applyUpdatedContact(userUpdateData.data);
  }

  private async savePartnerOwner() {
    const contactInfo = cloneDeep(this.contactInfoLocal);
    const contactUser: any = {
      ownerUserId: contactInfo.id,
    };
    const api = new PartnersApi(AppModule.apiConfig);
    const partner = await api.patchPartnerById(this.partnerID, contactUser);
    const { ownerUserId } = partner.data;
    const userApi = new UserApi(AppModule.apiConfig);
    const userData = await userApi.getUser(ownerUserId!);
    await this.applyUpdatedContact(userData.data);
  }

  /**
   * Refresh name/email/phone from GET responses and sync to parent.
   */
  private async applyUpdatedContact(updatedUser: User) {
    const freshUser = cloneDeep(updatedUser);
    this.contactInfoLocal = freshUser;
    this.contactInfoSync = freshUser;
    this.$emit('input', freshUser);

    const ownerName = await this.fetchPartnerOwnerName(freshUser);
    this.partnerOwnerNameSync = ownerName;
  }

  private async fetchPartnerOwnerName(user: User) {
    const fallbackName = Format.getFormattedName(user);
    if (!this.partnerID) {
      return fallbackName;
    }

    try {
      const partnerApi = new PartnersApi(AppModule.apiConfig);
      const partner = await partnerApi.getPartnerById(this.partnerID);
      const relationship = (partner.data as any)?._relationship;
      return relationship?.partnerOwnerName || fallbackName;
    } catch {
      return fallbackName;
    }
  }
}
